/** Guest-facing summary of section 4.2 of the cabin rental agreement. */
export const FIRM_CANCELLATION_POLICY = "Full refund only if you cancel within 48 hours of making the booking AND the booking was made at least 14 days before check-in. Otherwise, reservations are non-refundable.";

export function isWithinFirmCancellationWindow(checkIn: string | Date, createdAt: string | Date | null | undefined, now = Date.now()): boolean {
  if (!createdAt) return false;
  const bookedAt = new Date(createdAt).getTime();
  const leadTime = new Date(checkIn).getTime() - bookedAt;
  const age = now - bookedAt;
  return age >= 0 && age <= 48 * 3600000 && leadTime >= 14 * 86400000;
}

/** Match the API's deterministic US-number checks before any network request. */
export function normalizeQuotePhone(raw: string): string | null {
  const digits = raw.replace(/\D/g, "");
  const ten = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(ten) || /^(\d)\1{9}$/.test(ten) || ten.slice(3, 6) === "555") return null;
  return `+1${ten}`;
}
